import axios from '../../plugins/axios';

export default {
    namespaced: true,
    state: {
        entities: [],
        active: null,
        loaded: false
    },

    mutations: {
        SET_ENTITIES(state, payload) {
            state.entities = payload;
            state.active = payload.length ? payload[0] : null;
            state.loaded = true;
        },
        SET_LOADED(state) {
            state.loaded = true;
        }
    },
    actions: {
        async fetch({ commit, rootGetters }) {
            const { data } = await axios.get('/front/surveys');

            let entities = data;
            try {
                const abConfig = rootGetters['remoteConfig/getAbTestConfig']
                    ? rootGetters['remoteConfig/getAbTestConfig']('onboarding_3_0') || {}
                    : {};
                console.log(abConfig);
                if (abConfig.survey === false && typeof abConfig.survey_id === 'number') {
                    entities = entities.filter(item => item.id !== abConfig.survey_id);
                }
            } catch (e) {
                // в случае ошибки фильтрации просто используем оригинальный список
            }

            commit('SET_ENTITIES', entities);
        },
        async saveResult({ commit, dispatch }, { results, device_id }) {
            await axios.post('/front/surveys/results', { results, device_id });
            dispatch('fetch');
        }
    }
};
